<template>
  <v-form ref="fm_finish_step">
      <v-card outlined tile elevation="2" class="mt-2" v-if="$store.getters.getUnitMsg">
          <v-card-title class="font-weight-light mb-2 pb-0">A Message From Your Local</v-card-title>
          <v-card-text v-html="$store.getters.getUnitMsg">
          </v-card-text>
      </v-card>
      <v-card outlined tile elevation="2" class="mt-2">
          <v-card-title class="font-weight-light mb-2 pb-0">Terms, Conditions, and Signature</v-card-title>
          <v-card-text>
            <div class='d-flex flex-column'>                
                <v-textarea
                  ref="oma_additional_comment"
                  v-model="oma_additional_comment"
                  name="oma_additional_comment"
                  label="Is there anything you'd like us to know?"
                  :counter="addCommentLength"
                  :rules="[rules__oma_additional_comment]"
                  outlined
                  filled
                ></v-textarea>
                <div class="d-flex flex-column flex-md-row align-center">
                  <v-checkbox
                    ref="oma_terms_read_flag"
                    v-model="oma_terms_read_flag"
                    value="1"
                    :ripple="false"
                    :rules="[rules__oma_terms_read_flag]"
                    hide-details
                    class="m-0"
                  >
                    <template #label>
                      <div class="d-flex flex-column flex-md-row align-center">
                        <span>I have read and agree to the</span>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-btn plain class="blue--text text--darken-3 px-0 pl-1" dense style="padding-top:5px;" @click="show_main_terms=true;"> terms and conditions</v-btn>
                </div>
                <div class="d-flex flex-column flex-md-row align-center">
                  <v-checkbox
                    ref="oma_pac_terms_read_flag"
                    v-if="$store.state.oma_mea_pac_contribution_ind == 1"
                    v-model="oma_pac_terms_read_flag"
                    value="1"
                    :ripple="false"
                    :rules="[rules__oma_pac_terms_read_flag]"
                    hide-details
                    class="m-0"
                  >
                    <template #label>
                      <div class="d-flex flex-column flex-md-row align-center">
                        <span>I have read and agree to the</span>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-btn v-if="$store.state.oma_mea_pac_contribution_ind == 1" plain class="blue--text text--darken-3 px-0 pl-1" dense style="padding-top:5px;" @click="show_pac_terms=true;"> PAC terms and conditions</v-btn>           
                </div>
            </div>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  ref="oma_sign_sig_data"
                  v-model="oma_sign_sig_data"              
                  :rules="[rules__oma_sign_sig_data]"
                  validate-on-blur
                >
                  <template #label>
                    Enter your legal name<span class="required red--text"> *</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <div style="font-size:0.75em;">
              By My Signature, I indicate that I have read, understand and agree to the terms of this Agreement. I acknowledge that I have not been subject to any duress, intimidation, threats, or coercion in the execution of this Agreement. By typing my name or any other symbol or mark that I intend to represent as my electronic signature in the signature box above, I am agreeing to conduct this transaction by electronic means, and it is my intent to sign this Agreement electronically.
            </div>           
          </v-card-text>
      </v-card>
      <v-row class="justify-center">
          <v-col cols="12" class="d-flex flex-column flex-md-row justify-space-between">
              <v-btn
                  color="grey darken-3"
                  tile
                  @click="$emit('go-back')"
                  dark
                  class='my-2'
              >
                  Go Back
              </v-btn>
              <v-btn
                  color="rgb(0 48 87)"
                  tile
                  @click="validate_and_complete"
                  dark
                  class='my-2'
              >
                  Complete Application
              </v-btn>
          </v-col>
      </v-row>
      <saving-progress-dialog :showDialog="showSavingProgress"></saving-progress-dialog>
      <error-dialog :showDialog="showError" :errorObject="errorObj" :errorIsFatal="errorIsFatal" @close-dialog="showError = false;"></error-dialog>
      <terms-and-conditions-dialog :showDialog="show_main_terms" :termsDetails="$store.getters.getMainTerms" @close-dialog="show_main_terms = false;"></terms-and-conditions-dialog>
      <terms-and-conditions-dialog :showDialog="show_pac_terms" :termsDetails="$store.getters.getPacTerms" @close-dialog="show_pac_terms = false;"></terms-and-conditions-dialog>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import TermsAndConditionsDialog from './DialogComponents/TermsAndConditionsDialog.vue'
  import ErrorDialog from './DialogComponents/ErrorDialog.vue'
  import SavingProgressDialog from './DialogComponents/SavingProgressDialog.vue'
  import { format } from 'date-fns'
  import commonMixins from '@/mixins/commonMixins'
  export default {
    components: { TermsAndConditionsDialog, ErrorDialog, SavingProgressDialog},
    mixins:[commonMixins],
    name: 'FinishStep',
    data:() => ({
        show_main_terms: false,
        oma_terms_read_flag: null,
        show_pac_terms:false,
        oma_pac_terms_read_flag: null,
        oma_sign_sig_data:null,            
        showError :false,
        errorObj: {},
        errorIsFatal: false,
        showSavingProgress: false,
        addCommentLength : 175
    }),
    computed:{
      oma_terms_tc_id(){
        return this.$store.getters.getMainTerms['map_tc'];
      },
      oma_terms_read(){
        return format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      },
      oma_pac_terms_tc_id(){
        return this.$store.getters.getPacTerms['map_tc'];
      },
      oma_pac_terms_read(){
        return format(new Date(), 'yyyy-MM-dd HH:mm:ss')
      },
      oma_additional_comment:{
          get(){
              return this.$store.state.oma_additional_comment;
          },
          set(value){
              this.$store.state.oma_additional_comment = value;
          }
      },
    },
    methods:{
        rules__oma_sign_sig_data: function(v){
          if(v=='') return 'Please enter your legal name as a signature';
          const regex = this.$store.getters.getSignatureRegex;
          if(!regex.test(v)) return `The signature doesn't match the name entered in step one.`;
          return true;
        },
        rules__oma_additional_comment: function(v){
          if(!v) return true;
          if(v.length > this.addCommentLength) return `Only ${this.addCommentLength} characters allowed`;
          return /^[\w\s.?,'()[\]{}/^!&#;:@=%$*+\\-]+$/.test(v) || 'Additional comment contains invalid characters'
        },
        rules__oma_terms_read_flag:function(v){
          return v == '1' || 'Please confirm you have read and agree to the terms and conditions';
        },
        rules__oma_pac_terms_read_flag:function(v){
          return v == '1' || 'Please confirm you have read and agree to the terms and conditions';
        },        
        async validate_and_complete(){
          if(!this.$refs.fm_finish_step.validate()) return;
          this.showSavingProgress = true;
          //don't complete if there's still a pending update. give it 500ms to finish then try again
          if(this.$store.state.pending_update){
              setTimeout(()=>{this.validate_and_complete()}, 500);
              return;
          }
          
          // get all the form data to update the db
          const formData = {
            doCmd: 'update_db',
            app_id: window.sessionStorage.getItem('appID'),                
            oma_terms_read: this.oma_terms_read,
            oma_terms_read_flag: this.oma_terms_read_flag,
            oma_terms_tc_id: this.oma_terms_tc_id,
            oma_additional_comment: this.oma_additional_comment            
          }

          if(this.$store.state.oma_mea_pac_contribution_ind == 1){
            formData['oma_pac_terms_read'] = this.oma_pac_terms_read;
            formData['oma_pac_terms_read_flag'] = this.oma_pac_terms_read_flag;
            formData['oma_pac_terms_tc_id'] = this.oma_pac_terms_tc_id;
          }

          this.log_activity(`Attempting to update database with finish step`);

          const update_db = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(formData), {
              headers : {'Content-Type': 'application/json'}
          });

          if(update_db.data.result.has_error){
              this.showError = true;
              let errors = [];
              update_db.data.result.fail.forEach(v => errors.push(`REF# ${v.errorref} - ${v.errortext} <br/>`))
              this.errorObj = {errorref:false, errortext:errors.join('')};
              this.errorIsFatal = false;
              this.showSavingProgress = false;
              return;
          }

          if(update_db.data.error > 0){
              this.showError = true;
              this.errorObj = {errorref:update_db.data.errorref, errortext:update_db.data.errortext};
              this.errorIsFatal = false;
              this.showSavingProgress = false;
              return;
          }
            
          
          const app_id = window.sessionStorage.getItem('appID');              
          const complete_app = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify( {doCmd: 'complete_application', app_id:app_id, oma_sign_sig_data:this.oma_sign_sig_data}),  {
                headers : {'Content-Type': 'application/json'}
            });

          const {data:{ error, errortext, errorref } } = complete_app;
          if(error > 0){
            this.showError = true;
            this.errorObj = {error: error, errorref:errorref, errortext: errortext};
            this.errorIsFatal = false;
            this.showSavingProgress = false;
            return false;
          }

          //app is complete, clear session storage and redirect to survey
          window.sessionStorage.clear();
          window.location.href = `${this.$store.state.survey_url}&referer=oma&referer_id=${app_id}`;
          this.$destroy();
        }
    },
  }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap');
.v-input--selection-controls.v-input--checkbox{
  margin-top:0px!important;
}
</style>